import { HttpErrorResponse } from '@angular/common/http';
import { ErrorResponse } from '@core/error/error-response.model';
import { EMPTY, ObservedValueOf, OperatorFunction } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StartWithUnit } from './start-with-unit';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiError = Record<string, any>;
export type ApiErrorExtra = { extra: { fields: { [key: string]: string[] } } };

export enum ApiErrorCode {
    AuthenticationFailed = 'authentication_failed',
    NotFound = 'not_found',
    Used = 'used',
    IsDraft = 'is_draft',
    PermissionDenied = 'permission_denied',
    NotVerified = 'not_verified',
    Invalid = 'invalid',
}

export function startWithErrors<T, V extends { errors: Record<StartWithUnit, ApiError> }>(
    state: any,
    unit: StartWithUnit,
    rethrow = false,
): OperatorFunction<T, T | ObservedValueOf<never>> {
    return catchError((errorResponse: HttpErrorResponse) => {
        const errors: ApiError = errorResponse instanceof HttpErrorResponse ? errorResponse.error : errorResponse;

        state.set({ errors: { [unit]: typeof errors === 'string' ? JSON.parse(errors) : errors } } as V);

        if (rethrow) {
            throw errors;
        }

        return EMPTY;
    });
}

export const getErrorProp: (
    prop: StartWithUnit,
) => OperatorFunction<Record<StartWithUnit, ErrorResponse>, ErrorResponse> = (prop: StartWithUnit) => {
    return map((errors: Record<StartWithUnit, ErrorResponse>) => errors?.[prop]);
};
